import angular from 'angular';
import { Invoice } from '../model/invoice';
import moment from 'moment';
angular
  .module('cxInvoicing')
  .controller('TransactionPaymentDialogCtrl', [
    '$element',
    'invoicingSvc',
    'transactionHttpSvc',
    'flySvc',
    '$filter',
    'close',
    'transaction',
    'invoice',
    transactionPaymentDialogCtrl,
  ]);

function transactionPaymentDialogCtrl(
  $element,
  invoicingSvc,
  transactionHttpSvc,
  flySvc,
  $filter,
  close,
  transaction,
  invoice,
) {
  var vm = this;
  vm.saving = false;
  if (!transaction || !transaction.id) {
    console.error('Transaction required');
    return;
  }

  vm.showValidation = false;

  vm.transaction = transaction;
  if (typeof vm.transaction.date === 'string')
    vm.transaction.date = new moment(vm.transaction.date.substr(0, 10)).toDate();

  vm.invoice = invoice;
  if (vm.invoice && !(vm.invoice instanceof Invoice)) {
    vm.invoice = new Invoice(vm.invoice);
  }
  vm.invoices = [];

  function loadUnpaidInvoices() {
    invoicingSvc
      .retrieveUnpaidInvoices(100, { ownCompanies: [vm.transaction.companyId] })
      .then(function(result) {
        vm.invoices = result;
      });
  }

  vm.searchInvoice = function(search) {
    if (!search) return vm.invoices;
    return invoicingSvc.searchUnpaidInvoices(search);
  };
  vm.clearInvoice = function() {
    vm.invoice = null;
    vm.invoiceSearch = null;
  };

  function calcAmount() {
    return vm.invoice && vm.invoice.dueAmount() < vm.transaction.openAmount()
      ? vm.invoice.dueAmount()
      : vm.transaction.openAmount();
  }
  vm.payment = {
    invoiceId: invoice ? invoice.id : null,
    amount: calcAmount().round(2),
    remark: vm.transaction.description || '',
  };

  if (!vm.invoice) {
    if (vm.transaction.matches && vm.transaction.candidates) {
      // Already matched via auto-link all
      if (vm.transaction.candidates.length) {
        vm.invoices = $.map(vm.transaction.candidates, function(inv) {
          return new Invoice(inv);
        });
      } else {
        loadUnpaidInvoices();
      }
    } else {
      loadUnpaidInvoices();
      transactionHttpSvc.matchTransaction(vm.transaction.id).then(function(result) {
        if (result && result.matches && result.matches.length) {
          var payment = null;
          if (result.matches.length === 1) {
            payment = result.matches[0];
          } else {
            payment = result.matches.find(function(p) {
              return p.amount === vm.transaction.amount;
            });
          }
          if (payment) vm.transaction.payments.push(payment);
          $element.modal('hide');
          close(payment, 500); //Matching was a success
        } else if (result && result.candidates && result.candidates.length) {
          vm.invoices = $.map(result.candidates, function(inv) {
            return new Invoice(inv);
          });
        }
      });
    }
  } else {
    loadUnpaidInvoices();
  }

  vm.selectInvoice = function(invoice) {
    if (!invoice || !invoice.id) return;
    if (invoice instanceof Invoice) {
      vm.invoice = invoice;
    } else {
      vm.invoice = new Invoice(invoice);
    }
    vm.payment.amount = calcAmount().round(2);
  };
  vm.invoiceLabel = function(item) {
    if (!item) return null;
    return (
      item.number +
      ': ' +
      $filter('relationName')(item.customer) +
      ' -  ' +
      $filter('dynCurrency')(item.amount) +
      '  [' +
      $filter('formatDate')(item.date) +
      ']'
    );
  };

  vm.save = function() {
    if (vm.saving) return;
    vm.saving = true;
    vm.payment.invoiceId = vm.invoice.id;
    transactionHttpSvc.createPayment(vm.transaction.id, vm.payment).then(
      function(result) {
        if (result) {
          if (vm.transaction) vm.transaction.payments.push(result);
        }
        vm.saving = false;
        $element.modal('hide');
        close(result, 500);
      },
      function(error) {
        vm.saving = false;
        flySvc.error(error.data.code, error.data.parameters);
      },
    );
  };

  vm.cancel = function() {
    close(null, 500);
  };
}
